import { useQuery } from '@tanstack/react-query';
import type { Insurer, Owner, OwnerInsurer } from 'app/types';
import insurerService from 'app/Domain/Insurers/Services/InsurerService/insurerService';

type UseOwnerInsurerQueryVariables = {
  ownerId: Owner['ownerId'] | undefined;
  insurerId: Insurer['insurerId'] | undefined;
};

export const OWNER_INSURERS_QUERY_KEY = 'getOwnerInsurers';

export const useOwnerInsurerQuery = ({ ownerId, insurerId }: UseOwnerInsurerQueryVariables) => {
  return useQuery(
    [OWNER_INSURERS_QUERY_KEY, ownerId],
    async () => {
      const response = await insurerService.getOwnerInsurers({ ownerId: ownerId!, page: 1, pageSize: 100 });
      return (Array.isArray(response.data) ? response.data : response.data['hydra:member'] ?? []) as OwnerInsurer[];
    },
    {
      enabled: !!ownerId,
      select: (items: OwnerInsurer[]) => items.find(item => item.insurerId === insurerId) ?? null,
    },
  );
};
